export interface FavouritesAuthTokenClient {
  isAuthenticated?: {
    value: boolean;
  };
  getAccessTokenSilently: () => Promise<string | null | undefined>;
}

export async function getFavouritesAuthToken(auth0?: FavouritesAuthTokenClient): Promise<string> {
  if (!auth0?.isAuthenticated?.value) {
    return '';
  }

  try {
    const authToken = await auth0.getAccessTokenSilently();
    return authToken ?? '';
  } catch {
    return '';
  }
}
